export default {
  Gradebook: "Gradebook",
  Gradebooks: "Gradebooks",
  edit_gradebook: "Entering report cards",
  gradebook_finalization: "Finalization of report cards",
  empty_gradebook: "No report card exists at this time.",
  empty_gradebook_subject: "No subject is covered by this period.",
  empty_gradebook_subject_exam: "No exam has been recorded for this subject.",
  classroom: "Classroom",
  gradebook: {
    absent: "Absent",
    coefficient: {
      short: "Coef",
    },
    mark: "Mark",
    appreciation: "Appreciation",
    appreciations: "Appreciations",
    success: "Your change has been successfully processed!",
    min: "Min",
    max: "Max",
    average: {
      short: "Avg",
      session: "Average over the period",
    },
    export: {
      excel: {
        title: "Export the report card to Excel",
        confirmation: "Are you sure you want to export the report card to Excel?",
      },
      pdf: {
        title: "Export the report card as PDF",
        confirmation: "Are you sure you want to export the report card of this trio as a PDF?",
        all: {
          title: "Export all report cards as PDF",
          confirmation: "Are you sure you want to export the report cards of this cohort as a PDF?",
        },
      },
    },
    comment: {
      title: "Assessment",
      general: "Overall assessment",
      placeholder: "Add a comment (optional)",
    },
    session: {
      is_valid: "This session has been validated and is visible to members of the trios.",
      is_not_valid: "This session has not yet been validated and is not visible to members of the trios.",
      valid: "Publish the grades of the active session",
      unlock: "Unlock the active session",
      valid_confirmation: "Are you sure you want to confirm the entry for the active session?",
      unlock_confirmation: "Are you sure you want to unblock the active session?",
      valid_success: "Session successfully published!",
      unlock_success: "Session successfully unlocked!",
      already_pulished: "This session is already published; you cannot modify it.",
      ended: "This session has ended; it is not possible to publish it.",
    },
    triad: {
      unlock_entry: "Unlock the entry for this note",
      valid_entry: "Confirm entry of this note",
      valid_confirmation: "Are you sure you want to confirm this note?",
      unlock_confirmation: "Are you sure you want to unblock the entry of this note?",
      valid_success: "Note successfully validated!",
      unlock_success: "Note successfully unlocked!",
      save_note: "Save note entry",
    },
    exam_type: "Type of examination",
    percent: {
      title: "Percentage of the examination",
      help: "Weighting of the examination mark in the calculation of the subject mark",
    },
    too_much_percent: "The sum of the percentages for the examinations in this subject must equal 100.",
    percentage: {
      edit: {
        valid: "Validate percentage entry",
        success: "Percentage successfully recorded!",
      },
    },
    ects: "ECTS credits",
    exempt: "Exempt",
    reminder: {
      title: "Remind the former",
      confirmation: "Are you sure you want to follow up with this trainer?",
      success: "Reminder sent successfully!",
    },
    formers: {
      title: "Formers",
    },
    write_by: ({ named }) => `Entered by ${named("user")} on ${named("date")}`,
    write_on: ({ named }) => `, on ${named("date")}`,
    exemption: "Exemption",
    empty_subject: "No subject is specified, please add one by clicking here first",
  },
};
